<template>
  <div class="fromStyle areaContainer">
    <a-form :form="form" @submit="handleSubmit">
      <a-form-item label="物料名称" v-bind="formItemLayout">
        <a-input
          v-decorator="[
            'name',
            { rules: [{ required: true, message: '请选择项目!' }] }
          ]"
        />
      </a-form-item>
      <a-form-item label="单价" v-bind="formItemLayout">
        <a-input-number
          :min="0"
          v-decorator="[
            'price',
            { rules: [{ required: true, message: '请选择项目!' }] }
          ]"
        />
        <span>&nbsp;元</span>
      </a-form-item>
      <a-form-item label="类型" v-bind="formItemLayout">
        <a-radio-group v-model="type">
          <a-radio :value="1">工具</a-radio>
          <a-radio :value="2">消耗品</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="单位" v-bind="formItemLayout">
        <a-input
          v-decorator="[
            'unit',
            { rules: [{ required: true, message: '请选择项目!' }] }
          ]"
        />
      </a-form-item>
      <a-form-item label="双周工单消耗/个" v-bind="formItemLayout">
        <a-input-number
          v-decorator="[
            'double_consume',
            { rules: [{ required: true, message: '请选择项目!' }] }
          ]"
        />
      </a-form-item>
      <a-form-item :wrapper-col="{ span: 12, offset: 5 }">
        <a-button type="primary" html-type="submit">提交</a-button>
      </a-form-item>
    </a-form>
  </div>
</template>

<script>
import axios from "axios";
export default {
  inject: ["reload"],
  data() {
    return {
      formLayout: "horizontal",
      form: this.$form.createForm(this),
      formItemLayout: {
        labelCol: { span: 5 },
        wrapperCol: { span: 12 }
      },
      type: 2,
      detail: {}
    };
  },
  mounted() {
    if (this.editDetail != undefined) {
      this.getDetail();
    }
  },
  props: {
    editDetail: {}
  },
  watch: {
    editDetail() {
      this.detail = this.editDetail;
      this.getDetail();
    }
  },
  methods: {
    getDetail() {
      this.type = this.editDetail.type;
      this.form = this.$form.createForm(this, {
        mapPropsToFields: () => {
          return {
            name: this.$form.createFormField({
              ...this.name,
              value: this.editDetail.name
            }),
            price: this.$form.createFormField({
              ...this.price,
              value: Number(this.editDetail.price)
            }),
            double_consume: this.$form.createFormField({
              ...this.double_consume,
              value: Number(this.editDetail.double_consume)
            }),
            unit: this.$form.createFormField({
              ...this.unit,
              value: this.editDetail.unit
            })
          };
        }
      });
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, val) => {
        if (!err) {
          let url =
            this.httpsBasic.url +
            this.httpsBasic.clean +
            "Material/editMaterial";
          let params = {
            id: this.detail.id,
            name: val.name,
            price: val.price,
            type: this.type,
            unit: val.unit,
            double_consume: val.double_consume,
            token: window.localStorage.getItem("xnwfPcToken")
          };
          if (this.type != 2) {
            delete val.double_consume;
          }
          axios
            .post(url, params)
            .then(res => {
              if (res.data.code == 200) {
                this.$message.success("提交成功");
                this.form.resetFields();
                this.$emit("hideInEdit", false);
              } else {
                this.$message.warning(res.data.message);
              }
            })
            .catch(err => {
              this.$message.error("服务器出错了...");
            });
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.fromStyle {
  margin: 12% 4%;
}
</style>
<style lang="less">
.areaContainer {
  .area-select {
    height: unset;
    margin-bottom: 10px;
    .area-selected-trigger {
      padding: 0 20px 0 12px;
    }
  }
}
</style>
